export function DocumentCopy({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.75 10.559V12.809C12.75 15.809 11.55 17.009 8.55 17.009H5.7C2.7 17.009 1.5 15.809 1.5 12.809V9.95903C1.5 6.95903 2.7 5.75903 5.7 5.75903H7.95"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7497 10.559H10.3497C8.54971 10.559 7.94971 9.95903 7.94971 8.15903V5.75903L12.7497 10.559Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.69971 2.00903H11.6997"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 4.25903C5.25 3.01403 6.255 2.00903 7.5 2.00903H9.465"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4996 6.50903V11.1515C16.4996 12.314 15.5546 13.259 14.3921 13.259"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 6.50903H14.25C12.5625 6.50903 12 5.94653 12 4.25903V2.00903L16.5 6.50903Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
